
import { BusinessUnitEntityDecorator } from '../../businessunit/model/business-unit.decorator';
import { BusinessUnit } from '../../businessunit/model/business-unit.model';
import { FirearmAssignmentEntityDecorator } from '../../firearm_assignment/model/firearm-assignment.decorator';
import { FirearmAssignment } from '../../firearm_assignment/model/firearm-assignment.model';
import { RangerEntityDecorator } from '../../ranger/model/ranger.decorator';
import { Ranger } from '../../ranger/model/ranger.model';
import { RANGER_FIREARM_ASSIGNMENT_LOG_METADATA } from './ranger-firearm-assignment-log.metadata';
import { RangerFirearmAssignmentLog } from './ranger-firearm-assignment-log.model';
import { EntityDecorator, GenericEntityDecorator } from '@scisys-uim/uim-common';


export abstract class RangerFirearmAssignmentLogEntityDecoratorBase extends GenericEntityDecorator<RangerFirearmAssignmentLog, number> {
  constructor() {
    super(RANGER_FIREARM_ASSIGNMENT_LOG_METADATA, {
      get assignments(): EntityDecorator<FirearmAssignment, number> {
        return new FirearmAssignmentEntityDecorator();
      },
      get businessUnit(): EntityDecorator<BusinessUnit, string> {
        return new BusinessUnitEntityDecorator();
      },
      get ranger(): EntityDecorator<Ranger, number> {
        return new RangerEntityDecorator();
      }
    }, {
    });
  }
  toKeyObjectFromRouteParams(params: any): number {
    if (params == null || params.rangerId == null) {
      return null;
    }
    return parseInt(params.rangerId);
  }
  toKeyUrlPathSegments(key: number): string {
    if (key == null) {
      return null;
    }
    return '' + key;
  }
  toKeyRouteSegments(item: RangerFirearmAssignmentLog): any[] {
    const key: number = this.metadata?.toKeyObject(item);
    if (key == null) {
      return null;
    }
    return [key];
  }
}




